import React, { FunctionComponent } from "react";
import { IconButton } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { grayscaleText } from "../../styles/theme";

interface ChatSelectButtonProps {
	selected: boolean;
	onToggle: () => void;
}

const ChatSelectButton: FunctionComponent<ChatSelectButtonProps> = ({
	selected,
	onToggle,
}) => {
	return (
		<IconButton
			size="small"
			onClick={onToggle}
			sx={{
				position: "absolute",
				bottom: "10px",
				right: "10px",
				zIndex: 2,
				backgroundColor: "white",
				"&:hover": {
					backgroundColor: "white",
				},
			}}
		>
			{selected ? (
				<CheckCircleIcon sx={{ color: grayscaleText }} />
			) : (
				<RadioButtonUncheckedIcon sx={{ color: grayscaleText }} />
			)}
		</IconButton>
	);
};

export default ChatSelectButton;
